import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormField from './../../Forms/FormField/FormField';
import CustomButton from './../../Forms/CustomButton/CustomButton';
import './AddOption.scss';

const AddOption = ({maxCount, currentCount, onadd, onRemove, option, onChangeOption, onToggleCorrectOption}) => {
	if(option) {
		return (
			<div className='AddOption'>
				<div className={`actions ${option.correct_answer === 'Y' ? 'selected' : ''}`}>
					<CustomButton iconOnly iconName='tick_solid' name="correctAnswer" 
						onClick={() => onToggleCorrectOption(currentCount)} 
					/>
				</div>
				{(currentCount===0||currentCount===1)?<div className="option-star">*</div>:<div className="option-star">&nbsp;&nbsp;</div>}	
				<FormField 
					name="option_value"
					type="text"
					placeholder= {`enter option ${currentCount + 1}`}
					value={option.option_value}
					onChange={ e => onChangeOption(e, currentCount) }
					validate={['required']}
					multiline
				/>
				{currentCount === (maxCount - 1) && (
					<div className="actions">
						<CustomButton disabled={option === ''} iconOnly iconName='plus' name="Add New Options" onClick={onadd} />
						{currentCount > 1 && (
							<CustomButton
								iconOnly
								iconName='delete'
								name="delete Options"
								onClick={onRemove}
							/>
						)}
					</div>
				)}
			</div>
		);
	}
	return null;
}

AddOption.propTypes = {
    maxCount: PropTypes.number,
    currentCount: PropTypes.number,
    onadd: PropTypes.func,
    onRemove: PropTypes.func,
    option: PropTypes.instanceOf(Object),
    onChangeOption: PropTypes.func,
    onToggleCorrectOption: PropTypes.func
};

AddOption.defaultProps = {
    maxCount: null,
    currentCount: null,
    onadd: () => {},
    onRemove: () => {},
    option: {},
    onChangeOption: () => {},
    onToggleCorrectOption: () => {}
};

export default AddOption;


// WEBPACK FOOTER //
// ./common/AddQuestion/AddOption/AddOption.js